(function(){
  var WORKER_URL = (window.LL_WORKER_URL || 'https://levenslab-assistent.odd-glitter-4eb5.workers.dev/chat');

  var win = document.getElementById('ll-win');
  var fab = document.getElementById('ll-fab');
  var body = document.getElementById('ll-body');
  var chips = document.getElementById('ll-chips');
  var inp = document.getElementById('ll-inp');
  var send = document.getElementById('ll-send');
  var close = document.getElementById('ll-close');

  if (!win || !fab || !inp || !send) return;

  var history = [];
  var busy = false;

  function toggle(open) {
    if (open === undefined) open = !win.classList.contains('ll-open');
    win.classList.toggle('ll-open', open);
    if (open) setTimeout(function(){ inp.focus(); }, 100);
  }

  fab.addEventListener('click', function(){ toggle(); });
  close.addEventListener('click', function(){ toggle(false); });

  function renderMarkdown(text) {
    var safe = String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    safe = safe.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
    safe = safe.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(_, t, u){
      var href = u.replace(/"/g, '');
      return '<a href="' + href + '" target="_blank" rel="noopener">' + t + '</a>';
    });
    var lines = safe.split('\n');
    var html = '';
    var inList = false;
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var m = line.match(/^[-*]\s+(.+)$/);
      if (m) {
        if (!inList) { html += '<ul>'; inList = true; }
        html += '<li>' + m[1] + '</li>';
      } else {
        if (inList) { html += '</ul>'; inList = false; }
        if (line.trim()) html += line + '<br>';
      }
    }
    if (inList) html += '</ul>';
    return html.replace(/<br>\s*<br>/g, '<br>');
  }

  function addMsg(role, text) {
    var div = document.createElement('div');
    div.className = 'll-msg ' + role;
    div.innerHTML = role === 'bot' ? renderMarkdown(text) : text.replace(/</g, '&lt;');
    body.appendChild(div);
    body.scrollTop = body.scrollHeight;
    return div;
  }

  function addTyping() {
    var div = document.createElement('div');
    div.className = 'll-msg bot ll-typing-wrap';
    div.innerHTML = '<span class="ll-typing"><span></span><span></span><span></span></span>';
    body.appendChild(div);
    body.scrollTop = body.scrollHeight;
    return div;
  }

  async function ask(text) {
    if (busy || !text.trim()) return;
    busy = true;
    send.disabled = true;
    inp.disabled = true;
    chips.style.display = 'none';

    addMsg('user', text);
    history.push({ role: 'user', content: text });
    inp.value = '';

    var typing = addTyping();

    try {
      var res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ messages: history })
      });
      typing.remove();
      if (!res.ok) {
        var errBody = await res.text();
        console.error('LL assistent error:', res.status, errBody);
        addMsg('bot', 'Sorry, ik kan nu even niet antwoorden. Mail gerust naar info@levenslab.nl of probeer het zo nog eens.');
        history.pop();
      } else {
        var data = await res.json();
        var reply = (data.reply || '').trim();
        if (!reply) reply = 'Sorry, ik kon geen antwoord genereren. Mail je vraag naar info@levenslab.nl, dan helpen we je verder.';
        addMsg('bot', reply);
        history.push({ role: 'assistant', content: reply });
      }
    } catch (e) {
      typing.remove();
      console.error('LL assistent fetch error:', e);
      addMsg('bot', 'Sorry, de verbinding lukt niet. Mail naar info@levenslab.nl voor direct antwoord.');
      history.pop();
    } finally {
      busy = false;
      send.disabled = false;
      inp.disabled = false;
      inp.focus();
    }
  }

  chips.addEventListener('click', function(e){
    var btn = e.target.closest('.ll-chip');
    if (!btn) return;
    ask(btn.getAttribute('data-q'));
  });

  send.addEventListener('click', function(){ ask(inp.value); });
  inp.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); ask(inp.value); }
  });
})();
